function Terms() {
  return (
    <div className="min-h-screen bg-secondary-50">
      <div className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold text-secondary-900 mb-8">Términos de Uso</h1>
        
        <div className="prose prose-blue max-w-none">
          <p className="text-secondary-600 mb-6">
            Última actualización: 15 de febrero de 2025
          </p>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-secondary-800 mb-4">1. Aceptación de los Términos</h2>
            <p className="text-secondary-600">
              Al utilizar esta aplicación, usted acepta estos términos de uso en su totalidad. 
              Si no está de acuerdo con estos términos, por favor no utilice la aplicación.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-secondary-800 mb-4">2. Uso de la Aplicación</h2>
            <p className="text-secondary-600">
              Esta aplicación está diseñada para realizar selecciones aleatorias de participantes. 
              Usted se compromete a utilizarla de manera responsable y de acuerdo con todas las 
              leyes y regulaciones aplicables.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-secondary-800 mb-4">3. Propiedad Intelectual</h2>
            <p className="text-secondary-600">
              Esta aplicación es de código abierto y está disponible bajo la licencia MIT. 
              Puede utilizar, modificar y distribuir el código fuente de acuerdo con los términos 
              de dicha licencia.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-secondary-800 mb-4">4. Limitación de Responsabilidad</h2>
            <p className="text-secondary-600">
              La aplicación se proporciona "tal cual", sin garantías de ningún tipo. No nos hacemos 
              responsables por cualquier daño que pueda surgir del uso de la aplicación.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-secondary-800 mb-4">5. Contacto</h2>
            <p className="text-secondary-600">
              Si tiene alguna pregunta sobre estos términos, puede contactarnos en:
              <br />
              <a 
                href="mailto:info@reynergonzalez.com" 
                className="text-primary-600 hover:text-primary-700"
              >
                info@reynergonzalez.com
              </a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default Terms; 